import React, { FC } from 'react'
import { Container, Box, Image } from '@gassan-ui'
import RolexPage from '@components/_rolex/Page'
import { Page, pickSeoProps } from '@components/Page'
import { useLocalization } from '@components/Localization'
import KeepExploring from './Sliders/KeepExploring'
import { RolexNewWatches2020Live } from '@lib/kontent/models/RolexNewWatches2020Live'
import { SingleItemResponse, getKontentImage } from '@lib/kontent'
import TextBlock from '@components/_rolex/TextBlock'
import Hero from '@components/_rolex/Hero'
import RevealGrid from '@components/_rolex/RevealGrid'

type Props = SingleItemResponse<RolexNewWatches2020Live>

export const NewWatches2020: FC<Props> = ({ item, modular_content }) => {
  const { lang } = useLocalization()
  const keepExploringItems = item.elements.keep_exploring_slider_items.value.map(
    key => modular_content[key].elements
  )

  const featuredItems = [
    {
      images: [item.elements.first_mobile_image, item.elements.first_desktop_image],
      title: modular_content[item.elements.first_model_link.value[0]].elements.title.value,
      href: `${
        modular_content[item.elements.first_model_link.value[0]].elements.rolex_family.value[0].name
      }/${modular_content[item.elements.first_model_link.value[0]].elements.url_slug.value}`
    },
    {
      images: [item.elements.second_mobile_image, item.elements.second_desktop_image],
      title: modular_content[item.elements.second_model_link.value[0]].elements.title.value,
      href: `${
        modular_content[item.elements.second_model_link.value[0]].elements.rolex_family.value[0]
          .name
      }/${modular_content[item.elements.second_model_link.value[0]].elements.url_slug.value}`
    },
    {
      images: [item.elements.third_mobile_image, item.elements.third_desktop_image],
      title: modular_content[item.elements.third_model_link.value[0]].elements.title.value,
      href: `${
        modular_content[item.elements.third_model_link.value[0]].elements.rolex_family.value[0].name
      }/${modular_content[item.elements.third_model_link.value[0]].elements.url_slug.value}`
    },
    {
      images: [item.elements.fourth_mobile_image, item.elements.fourth_desktop_image],
      title: modular_content[item.elements.fourth_model_link.value[0]].elements.title.value,
      href: `${
        modular_content[item.elements.fourth_model_link.value[0]].elements.rolex_family.value[0]
          .name
      }/${modular_content[item.elements.fourth_model_link.value[0]].elements.url_slug.value}`
    }
  ]

  const sources: string[] = [
    item.elements.rolex_hero__mobile?.value[0]?.url,
    item.elements.rolex_hero__mobile?.value[0]?.url,
    item.elements.rolex_hero__desktop?.value[0]?.url
  ].filter(t => t)

  return (
    <Page
      {...pickSeoProps(item.elements)}
      slug={lang === 'nl' ? 'rolex/nieuwe-horloges-2020' : 'rolex/new-watches-2020'}
      altSlug={lang === 'nl' ? 'rolex/new-watches-2020' : 'rolex/nieuwe-horloges-2020'}
    >
      <RolexPage>
        <Hero sources={sources} alt={`Rolex - ${item.elements.title.value}`} />
        <TextBlock
          preTitle={item.elements.pre_title.value}
          title={item.elements.title.value}
          description={item.elements.body.value}
          pt={[30, 60]}
        />
        <Box mt={{ _: '2rem', large: '4rem', xlarge: '5rem' }}>
          <RevealGrid items={featuredItems} />
        </Box>
        <Box mb={{ _: '2rem', large: '5rem', xlarge: '6rem' }}>
          <Image
            ratio={[0.8, 0.8, 0.41]}
            alt={item.elements.mobile_image.value[0].description}
            sources={[
              getKontentImage(item.elements.mobile_image.value[0].url, { width: 600 }),
              getKontentImage(item.elements.desktop_image.value[0].url, { width: 1024 }),
              getKontentImage(item.elements.desktop_image.value[0].url, { width: 1440 }),
              getKontentImage(item.elements.desktop_image.value[0].url, { width: 2500 })
            ]}
            placeholder={getKontentImage(item.elements.mobile_image.value[0].url, { width: 30 })}
          />
        </Box>
        <Container>
          <KeepExploring
            items={keepExploringItems}
            title={item.elements.keep_exploring_title.value}
          />
        </Container>
      </RolexPage>
    </Page>
  )
}
